/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  width: 100%;
  min-width: 20rem;
  min-height: 4.375rem;
  max-height: 4.375rem;
}
:host > .wrapper {
  width: 100%;
  min-width: 20rem;
  height: 4.375rem;
}
:host > .wrapper .container {
  touch-action: none;
  display: grid;
  grid: 3.125rem 1.25rem/1.5rem auto 1.5rem;
}
:host > .wrapper .container > #scale {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: stretch;
}
:host > .wrapper .container > #scale > .scale-element {
  min-width: 10%;
  border-top: 1px solid var(--davinci-color-outline-light,#C5CACC);
  border-left: 1px solid var(--davinci-color-outline-light,#C5CACC);
  flex: 1 1 auto;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
:host > .wrapper .container > #scale > .scale-element > label {
  position: absolute;
  font-size: 0.75rem;
  font-weight: 600;
  color: #2C3133;
  color: var(--davinci-color-text-on-background, #2C3133);
  top: 0.75rem;
  left: 0.75rem;
  overflow-wrap: normal;
  max-width: 70%;
}
:host > .wrapper .container > #scale > .scale-element:nth-child(odd) {
  background-color: #FBFCFC;
  background-color: var(--davinci-color-background-2, #FBFCFC);
}
:host > .wrapper .container > #scale > .scale-element:nth-child(even) {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
}
:host > .wrapper .container > #scale > .scale-element:last-child {
  border-right: 1px solid var(--davinci-color-outline-light,#C5CACC);
}
:host > .wrapper .container > .scrollbar {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-top: 1px solid var(--davinci-color-outline-light,#C5CACC);
  border-bottom: 1px solid var(--davinci-color-outline-light,#C5CACC);
}
:host > .wrapper .container > .scrollbar svg {
  display: inline-block;
  fill: #737F85;
  fill: var(--davinci-color-secondary, #737F85);
  z-index: 1;
  height: 75%;
}
:host > .wrapper .container > .scrollbar#scrollbar-left {
  grid-column: 1;
  grid-row: 2;
  border-left: 1px solid var(--davinci-color-outline-light,#C5CACC);
}
:host > .wrapper .container > .scrollbar#scrollbar-right {
  grid-column: 3;
  grid-row: 2;
  border-right: 1px solid var(--davinci-color-outline-light,#C5CACC);
}
:host > .wrapper .container > .middle {
  grid-column: 2;
  grid-row: 2;
  display: inline-block;
  border: 1px solid var(--davinci-color-outline-light,#C5CACC);
}
:host > .wrapper .svg-container {
  margin-left: 1.5rem;
  position: relative;
  bottom: 100%;
  height: 100%;
  width: calc(100% - 3rem);
  touch-action: none;
  fill: #737F85;
  fill: var(--davinci-color-secondary, #737F85);
}
:host > .wrapper .svg-container path {
  stroke: #FFFFFF;
  stroke: var(--davinci-color-background, #FFFFFF);
}
:host > .wrapper .svg-container svg#selector-mid {
  position: absolute;
  height: 100%;
  min-width: 1px;
}
:host > .wrapper .svg-container svg#selector-mid .overlay {
  fill: #8E989D;
  fill: var(--davinci-color-outline, #8E989D);
}
:host > .wrapper .svg-container svg.selectors {
  position: absolute;
  height: 2.25rem;
  top: 0.4375rem;
}`;
export { style };
